module.exports = __webpack_public_path__ + "static/media/tirutsava.cb171d2b.png";